interface Props {
  className?: string;
}

export function StrataWorksLogo({ className }: Props) {
  return (
    <svg
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
    >
      {/* 3 parallel S-curves — no background, transparent */}
      <path
        d="M 21 49 C 37 49 37 28 21 28 C 5 28 5 7 21 7"
        stroke="#BF5C16"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M 28 49 C 44 49 44 28 28 28 C 12 28 12 7 28 7"
        stroke="#D06B1E"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M 35 49 C 51 49 51 28 35 28 C 19 28 19 7 35 7"
        stroke="#E57C28"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
